export default __webpack_public_path__ + "static/media/mission.d59e1cf4.png";